/* eslint-disable no-throw-literal */

import $store from '../store'

// const OPTS = { limit: 20, offset: 0 }

export class OdooService {
  static async kwRead (model, ids, fields) {
    const cl = $store.state.odoo.cli
    const data = await cl.read(model, ids, fields)
    return data
  }

  static async kwSearch (model, domain) {
    const cl = $store.state.odoo.cli
    const data = await cl.search(model, domain)
    return data
  }

  static async kwSearchRead (model, domain, fields, opts) {
    const cl = $store.state.odoo.cli
    const data = await cl.searchRead(model, domain, fields, opts)
    return data
  }

  static async kwCreate (model, data) {
    const cl = $store.state.odoo.cli
    const resp = await cl.create(model, data)

    return resp
  }

  static async kwDelete (model, id) {
    const cl = $store.state.odoo.cli
    return await cl.delete(model, id)
  }

  static async kwUpdate (model, id, data) {
    const cl = $store.state.odoo.cli
    return await cl.update(model, id, data)
  }

  static async kwExecute (model, method, params) {
    const cl = $store.state.odoo.cli
    return await cl.execute_kw(model, method, params)
  }
}
